import { Button } from "@mantine/core";
import { TbBrandPatreonFilled } from "react-icons/tb";

export function BecomePatreonButton() {
  return (
    <Button
      component="a"
      color="orange"
      href={"https://www.patreon.com/bePatron?u=29098019"}
      leftSection={<TbBrandPatreonFilled />}
      target="_blank"
    >
      Become a Patreon
    </Button>
  );
}
